import { PIXIElement } from "appworks/graphics/pixi/group";
import { Contract } from "appworks/utils/contracts/contract";
import { SlingoReelHighlightComponent } from "slingo/components/slingo-reel-highlight-component";
import { SlingoHighlightType } from "slingo/components/slingo-ticket-matrix-component";

export class FowlSlingoReelHighlightComponent extends SlingoReelHighlightComponent {
    public setHighlightAlpha(alpha: number) {
        this.highlights.forEach((highlight) => highlight.alpha = alpha);
    }

    protected getHighlightAnimationContract(highlight: PIXIElement, highlightType: SlingoHighlightType): Contract<void> {
        return Contract.empty();
    }
}
